// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1PiiH","left":"styles_left__3YplQ","desktopActions":"styles_desktopActions__g3Cwg","title":"styles_title__2mjCS"};